import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import { length, inc, prop, pathOr, not, head } from 'ramda'
import { getDataByKey, renderData, getTitleByKey, getOrderByKey, sortByInt, sortByFloat, isNotNil, isNotNilDataByKey, getTranslation, findIndexByKey, getFirstCowId } from '../../../../helpers'
import { useFetch, useSort } from '../../../../hooks'
import PageLoader from '../../../../components/PageLoader'
import Tabs from '../../../../modules/Tabs'
import { Parameters, CowsList, Heats, Overlap, Notes } from './tabs'
import Modal from '../../../../components/Modal'
import FormGenerateReport from '../../../../modules/forms/FormGenerateReport'
import Drawer from '../../../../components/Drawer'
import Sort from '../../../../modules/Sort'
import { StyledDrawerItemWrapper, StyledDrawerItemText, StyledDrawerItemIcon } from '../../../../components/Drawer/styled'
import Button from '../../../../components/inputs/Button'
import FormRemove from '../../components/FormRemove'
import FormEditHerdGrp from '../../components/FormEditHerdGrp'
import Icon from '../../../../components/Icon'
import { Store } from '../../../../context/store'
import { isEmpty } from 'ramda';
import FooterBar from '../../../../modules/FooterBar';
import ButtonDouble from '../../../../components/inputs/ButtonDouble';
import useBuffer from '../../../../hooks/useBuffer';
import FormAddNote from '../../components/FormAddNote';

const MyGroupsCard = () => {
    const { actions, state: { groupsList } } = Store();
    const history = useHistory();
    const { state, state: { grpid = null, grpname = null } = {} } = useLocation();
    const [myGroup, setMyGroup] = useState({ data: [] });
    const [isManageCowsList, setIsManageCowsList] = useState(false);
    const [notes, setNotes] = useState({ data: [], nextid: null });
    const { sortOrder, setSortOrder, sortItems, sort: sortCows } = useSort(getOrderByKey(myGroup, 'cowslist', []), 'mygroups', sortByInt);
    const getOrderOverlap = () => {
        return getOrderByKey(myGroup, 'overlap', []).map(i => ({ ...i, key: i.endpoint, direct: "asc" }))
    };
    const { sortOrder: sortOrderOverlap, setSortOrder: setSortOrderOverlap, sortItems: sortItemsOverlap } = useSort(getOrderOverlap(), 'mygroupsOverlap', sortByInt);
    const getOrderTableOverlap = () => {
        const overlap = getDataByKey(myGroup, 'overlap', {});
        return pathOr([], ['data', 'order'], overlap);
    };
    const { sortOrder: sortOrderTableOverlap, setSortOrder: setSortOrderTableOverlap, updateSortOrder: updateSortOrderTableOverlap, sortItems: sortItemsTableOverlap, sort: sortTableOverlap } = useSort(getOrderTableOverlap(), 'mygroupsTableOverlap', sortByFloat('value'));

    const { error, fetching, doFetch: getGroupCard } = useFetch({
        url: `/groupcard?grp_id=eq.${grpid}`,
        method: 'GET',
        lazy: true
    })

    const { doFetch: getGrpNotes } = useFetch({
        url: '/rpc/get_grp_notes',
        method: 'POST',
        loader: false,
        state: false
    })

    const { fetching: fetchingOverlap, doFetch: getOverlap } = useFetch({
        url: `/rpc/${sortOrderOverlap.endpoint}`,
        method: 'POST'
    })

    const doFetch = ({ item, loader, returnLastUpdate }) => new Promise(async (resolve, reject) => {
        const resGroupCard = await getGroupCard({
            url: `/groupcard?grp_id=eq.${item.grp_id}`,
            loader,
            returnLastUpdate
        })
        if (resGroupCard && isNotNilDataByKey(resGroupCard, 'overlap') && sortOrderOverlap.endpoint) {
            const resOverlap = await getOverlap({
                url: `/rpc/${sortOrderOverlap.endpoint}`,
                loader,
                data: {
                    grpid: item.grp_id
                }
            })
            if (resOverlap) {
                const res = {
                    ...resGroupCard,
                    data: [{
                        ...resGroupCard.data[0],
                        overlap: {
                            ...resGroupCard.data[0].overlap,
                            data: resOverlap
                        }
                    }]
                }
                resolve(res);
            }
        }
        resolve(resGroupCard);
    })

    const { index, setIndex, refetchBuffer, onClickPrevItem, onClickNextItem } = useBuffer({
        list: groupsList,
        doFetch: doFetch,
        setItem: item => setMyGroup(item),
        id: "grp_id",
        returnLastUpdate: true
    })

    const reFetchMyGroupCard = (param = {}) => {
        const { loader = false, refetchCurr = false, cbAfterFirstRequest } = param;
        return refetchBuffer({ loader, refetchCurr, cbAfterFirstRequest });
    }

    useEffect(() => {
        if (sortOrderOverlap.endpoint) {
            refetchBuffer({ loader: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sortOrderOverlap])

    useEffect(() => {
        if (myGroup.data.length > 0) {
            const orderTableOverlap = getOrderTableOverlap();
            if(not(isEmpty(orderTableOverlap))) {
                const nextOrder = head(orderTableOverlap);
                if(sortOrderTableOverlap.key !== nextOrder.key || sortOrderTableOverlap.direct !== nextOrder.direct) {
                    updateSortOrderTableOverlap(nextOrder);
                }
            }
            const updateNotes = async () => {
                const resNotes = await getGrpNotes({
                    data: {
                        grpid: myGroup.data[0].grp_id
                    }
                })
                if (resNotes) {
                    setNotes(resNotes)
                }
            }
            updateNotes();
            history.replace({
                pathname: `/manage/mygroups/${myGroup.data[0].grp_name}`,
                state: {
                    ...state,
                    grpid: myGroup.data[0].grp_id
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [myGroup])

    useEffect(() => {
        if (isNotNil(grpid)) {
            if (index === null) {
                const currIndex = findIndexByKey('grp_id', grpid, groupsList)
                setIndex(currIndex)
            }
        } else {
            history.push('/')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grpid, grpname])

    useEffect(() => {
        const cowslist = getDataByKey(myGroup, 'cowslist', {})
        if (!isEmpty(cowslist)) {
            actions.setCowsList(sortCows(cowslist.cows))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [myGroup, sortOrder])

    const handleClickSaveNote = async () => {
            const res = await getGrpNotes({
                data: {
                    grpid
                }
            })
            if (res) {
                setNotes(res)
            }
    }
    const handleClickNextNotes = async () => {
        const res = await getGrpNotes({
            data: {
                grpid,
                nextid: notes.nextid
            }
        })
        if (res) {
            setNotes(prevNotes => ({ data: res.data ? [...prevNotes.data, ...res.data] : [...prevNotes.data], nextid: res.nextid }))
        }
    }

    const renderDataState = renderData({ data: myGroup, error, fetching: fetching || fetchingOverlap });
    const drawerTranslation = getTranslation(myGroup, 'menu-modal');
    const getTitleHeadBar = () => {
        if (isManageCowsList) return drawerTranslation && drawerTranslation['move']['modal']['title']
        else return getDataByKey(myGroup, 'title', '')
    }

    return (
        <>
            {
                renderDataState({
                    fetching: () => (<PageLoader />),
                    error: error => (<div>{error.toString()}</div>),
                    data: data => (
                        <Tabs
                            headBar={{
                                title: getTitleHeadBar()
                            }}
                            tabs={[{
                                id: 'parameters',
                                name: getTitleByKey(data, 'parameters'),
                                headBarChildren: (
                                    <Drawer
                                        drawerItems={[
                                            {
                                                customContent: ({ handleToggleIsOpenDrawer }) => (
                                                    <Modal
                                                        renderOpenButton={
                                                            ({ handleToggleIsOpenModal }) => (
                                                                <StyledDrawerItemWrapper onClick={handleToggleIsOpenModal}>
                                                                    <StyledDrawerItemIcon name='edit' />
                                                                    <StyledDrawerItemText>
                                                                        {drawerTranslation && drawerTranslation['edit']['form-button']}
                                                                    </StyledDrawerItemText>
                                                                </StyledDrawerItemWrapper>
                                                            )
                                                        }
                                                    >
                                                        {
                                                            ({ handleToggleIsOpenModal }) => (
                                                                <FormEditHerdGrp
                                                                    grpid={getDataByKey(data, 'grp_id', null)}
                                                                    reFetchCard={reFetchMyGroupCard}
                                                                    onClickCancel={handleToggleIsOpenModal}
                                                                    onClickClose={
                                                                        () => {
                                                                            handleToggleIsOpenModal();
                                                                            handleToggleIsOpenDrawer();
                                                                        }
                                                                    }
                                                                    translation={drawerTranslation && drawerTranslation['edit']['modal']}
                                                                />
                                                            )
                                                        }
                                                    </Modal>
                                                )
                                            },
                                            {
                                                customContent: () => (
                                                    <Modal
                                                        renderOpenButton={
                                                            ({ handleToggleIsOpenModal }) => (
                                                                <StyledDrawerItemWrapper onClick={handleToggleIsOpenModal}>
                                                                    <StyledDrawerItemIcon name='remove' />
                                                                    <StyledDrawerItemText>
                                                                        {drawerTranslation && drawerTranslation['delete']['form-button']}
                                                                    </StyledDrawerItemText>
                                                                </StyledDrawerItemWrapper>
                                                            )
                                                        }
                                                    >
                                                        {
                                                            ({ handleToggleIsOpenModal }) => (
                                                                <FormRemove
                                                                    data={{
                                                                        grpid: getDataByKey(data, 'grp_id', null) || grpid
                                                                    }}
                                                                    url='/rpc/remove_herdgrp'
                                                                    urlUndo='/rpc/remove_herdgrp_undo'
                                                                    redirect='/manage/mygroups'
                                                                    onClickCancel={handleToggleIsOpenModal}
                                                                    translation={drawerTranslation && { ...drawerTranslation['delete']['modal'], error: drawerTranslation['delete']['error'] }}
                                                                />
                                                            )
                                                        }
                                                    </Modal>
                                                )
                                            }, {
                                                customContent: () => (
                                                    <Modal
                                                        renderOpenButton={
                                                            ({ handleToggleIsOpenModal }) => (
                                                                <StyledDrawerItemWrapper onClick={handleToggleIsOpenModal}>
                                                                    <StyledDrawerItemIcon name='report' />
                                                                    <StyledDrawerItemText>
                                                                        {drawerTranslation && drawerTranslation['report']['form-button']}
                                                                    </StyledDrawerItemText>
                                                                </StyledDrawerItemWrapper>
                                                            )
                                                        }
                                                    >
                                                        {
                                                            ({ handleToggleIsOpenModal }) => (
                                                                <FormGenerateReport
                                                                    type="grp"
                                                                    dataKey="grp_id"
                                                                    icon="groups"
                                                                    id={getDataByKey(data, 'grp_id', null)}
                                                                    report={{
                                                                        endpoint: "get_herdgrp_report_modal_data"
                                                                    }}
                                                                    endpointExecute={'reportgrpexecute'}
                                                                    onClickCancel={handleToggleIsOpenModal}
                                                                />
                                                            )
                                                        }
                                                    </Modal>
                                                )
                                            }
                                        ]}
                                    />
                                ),
                                component: <Parameters
                                    grpid={getDataByKey(data, 'grp_id', null)}
                                    infoBar={{
                                        lastUpdate: data.lastUpdate,
                                        translation: {
                                            info: getDataByKey(data, 'info', '')
                                        }
                                    }}
                                    parameters={getDataByKey(data, 'parameters', [])}
                                />,
                                showTab: isNotNilDataByKey(data, 'parameters')
                            }, {
                                id: 'cowslist',
                                name: getTitleByKey(data, 'cowslist'),
                                headBarChildren: (
                                    <>
                                        {
                                            isManageCowsList ?
                                                <Button noMargin transparent green onClick={() => setIsManageCowsList(false)}>{drawerTranslation && drawerTranslation['move']['modal']['buttons']['cancel']}</Button>
                                                :
                                                <>
                                                    <Sort
                                                        sortOrder={sortOrder}
                                                        setSortOrder={setSortOrder}
                                                        sortItems={sortItems}
                                                        translation={{
                                                            "order-close": getDataByKey(data, 'cowslist', {})['order-close'],
                                                            "order-title": getDataByKey(data, 'cowslist', {})['order-title'],
                                                            "title": getDataByKey(data, 'cowslist', {})['title']
                                                        }}
                                                    />
                                                    <Drawer
                                                        drawerItems={[
                                                            {
                                                                customContent: ({ handleToggleIsOpenDrawer }) => (
                                                                    <StyledDrawerItemWrapper onClick={() => {
                                                                        handleToggleIsOpenDrawer(); setTimeout(() => {
                                                                            setIsManageCowsList(true)
                                                                        }, 500);
                                                                    }}>
                                                                        <StyledDrawerItemIcon name='account' />
                                                                        <StyledDrawerItemText>
                                                                            {drawerTranslation && drawerTranslation['move']['form-button']}
                                                                        </StyledDrawerItemText>
                                                                    </StyledDrawerItemWrapper>

                                                                )
                                                            }, {
                                                                customContent: () => (
                                                                    <Modal
                                                                        renderOpenButton={
                                                                            ({ handleToggleIsOpenModal }) => (
                                                                                <StyledDrawerItemWrapper onClick={handleToggleIsOpenModal}>
                                                                                    <StyledDrawerItemIcon name='report' />
                                                                                    <StyledDrawerItemText>
                                                                                        {drawerTranslation && drawerTranslation['report']['form-button']}
                                                                                    </StyledDrawerItemText>
                                                                                </StyledDrawerItemWrapper>
                                                                            )
                                                                        }
                                                                    >
                                                                        {
                                                                            ({ handleToggleIsOpenModal }) => (
                                                                                    <FormGenerateReport
                                                                                    type="cow"
                                                                                    dataKey="row_id"
                                                                                    icon="cow"
                                                                                    id={getFirstCowId(sortCows, data)}
                                                                                    report={{
                                                                                        endpoint: "get_report_modal_data"
                                                                                    }}
                                                                                    endpointExecute={'reportexecute'}
                                                                                    onClickCancel={handleToggleIsOpenModal}
                                                                                />
                                                                            )
                                                                        }
                                                                    </Modal>
                                                                )
                                                            }
                                                        ]}
                                                    />
                                                </>
                                        }
                                    </>
                                ),
                                component: <CowsList
                                    grpid={getDataByKey(data, 'grp_id', null)}
                                    infoBar={{
                                        lastUpdate: data.lastUpdate,
                                        translation: {
                                            info: getDataByKey(data, 'info', '')
                                        }
                                    }}
                                    cowslist={getDataByKey(data, 'cowslist', [])}
                                    sortCows={sortCows}
                                    isManage={isManageCowsList}
                                    reFetchCard={reFetchMyGroupCard}
                                    translation={{
                                        buttons: drawerTranslation && drawerTranslation['move']['modal']['buttons'],
                                        info: drawerTranslation && drawerTranslation['move']['modal']['info'],
                                        footer: drawerTranslation && drawerTranslation['move']['modal']['footer'],
                                        grpmodal: drawerTranslation && drawerTranslation['grpmodal']
                                    }}
                                />,
                                showTab: isNotNilDataByKey(data, 'cowslist')
                            }, {
                                id: 'heats',
                                name: getTitleByKey(data, 'heats'),
                                component: <Heats
                                    grpid={getDataByKey(data, 'grp_id', null)}
                                    infoBar={{
                                        lastUpdate: data.lastUpdate,
                                        translation: {
                                            info: getDataByKey(data, 'info', '')
                                        }
                                    }}
                                    heats={getDataByKey(data, 'heats')}
                                />,
                                showTab: isNotNilDataByKey(data, 'heats')
                            }, {
                                id: 'overlap',
                                name: getTitleByKey(data, 'overlap'),
                                headBarChildren: <>
                                    <Sort
                                        sortOrder={sortOrderOverlap}
                                        setSortOrder={setSortOrderOverlap}
                                        sortItems={sortItemsOverlap}
                                        translation={{
                                            "order-close": getDataByKey(data, 'overlap', {})['order-close'],
                                            "order-title": getDataByKey(data, 'overlap', {})['order-title'],
                                            "title": getDataByKey(data, 'overlap', {})['title']
                                        }}
                                    />
                                    <Drawer
                                        drawerItems={[{
                                            customContent: () => (
                                                <Modal
                                                    renderOpenButton={
                                                        ({ handleToggleIsOpenModal }) => (
                                                            <StyledDrawerItemWrapper onClick={handleToggleIsOpenModal}>
                                                                <StyledDrawerItemIcon name='report' />
                                                                <StyledDrawerItemText>
                                                                    {drawerTranslation && drawerTranslation['report']['form-button']}
                                                                </StyledDrawerItemText>
                                                            </StyledDrawerItemWrapper>
                                                        )
                                                    }
                                                >
                                                    {
                                                        ({ handleToggleIsOpenModal }) => (
                                                            <FormGenerateReport
                                                                type="grp"
                                                                dataKey="grp_id"
                                                                icon="groups"
                                                                id={getDataByKey(data, 'grp_id', null)}
                                                                report={getDataByKey(data, 'report', null)}
                                                                endpointExecute={'reportgrpexecute'}
                                                                onClickCancel={handleToggleIsOpenModal}
                                                            />
                                                        )
                                                    }
                                                </Modal>
                                            )
                                        }]}
                                    />
                                </>
                                ,
                                component: <Overlap
                                    infoBar={{
                                        lastUpdate: data.lastUpdate,
                                        translation: {
                                            info: getDataByKey(data, 'info', '')
                                        }
                                    }}
                                    overlap={prop('data', getDataByKey(data, 'overlap'))}
                                    sortOrder={sortOrderTableOverlap}
                                    sortItems={sortItemsTableOverlap}
                                    setSortOrder={setSortOrderTableOverlap}
                                    sort={sortTableOverlap}
                                />,
                                showTab: isNotNilDataByKey(data, 'overlap')
                            },
                            {
                                id: 'notes',
                                name: getTitleByKey(data, 'notes'),
                                headBarChildren: (
                                    <Modal
                                    renderOpenButton={
                                        ({ handleToggleIsOpenModal }) => (
                                            <Button transparent noMargin onClick={handleToggleIsOpenModal}><Icon name='add' /></Button>
                                        )
                                    }
                                >
                                    {
                                        ({ handleToggleIsOpenModal }) => (
                                            <FormAddNote
                                                type="grp"
                                                id={getDataByKey(data, 'grp_id', null)}
                                                endpoint='/rpc/setgrpnote'
                                                translation={pathOr({}, ['add-note'], getDataByKey(data, 'notes', {}))}
                                                onClickCancel={handleToggleIsOpenModal}
                                                onClickSave={handleClickSaveNote}
                                            />
                                        )
                                    }
                                </Modal>
                                ),
                                component: <Notes
                                    notesFromKey={getDataByKey(data, 'notes', null)}
                                    notes={notes}
                                    onClickNextNotes={handleClickNextNotes}
                                />,
                                showTab: isNotNilDataByKey(data, 'notes')
                            }
                            ]}
                            showTabsHeader={!isManageCowsList}
                        />
                    )
                })
            }
            {
                !isManageCowsList &&
                <FooterBar noDivider>
                    {
                        length(groupsList) !== 0 &&
                        <ButtonDouble style={{ marginLeft: 'auto' }} onClickLeft={onClickPrevItem} onClickRight={onClickNextItem} disabled={length(groupsList) === 1}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Icon name="groups" width="24" height="24" />
                                <div style={{ fontSize: '12px' }}>{`${index !== null && index > -1 ? inc(index) : '-'}/${length(groupsList)}`}</div>
                            </div>
                        </ButtonDouble>
                    }
                </FooterBar>
            }
        </>
    )
}

export default MyGroupsCard
